import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface Module {
  emoji: string;
  title: string;
  chapters: string[];
}
interface ModuleAccordionProps {
  modules: Module[];
}
export function ModuleAccordion({
  modules
}: ModuleAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="space-y-3" data-id="element-100">
      {modules.map((module, index) => <div key={index} className="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-101">
          <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-gray-50 transition-colors duration-200" data-id="element-102">
            <div className="flex items-center gap-3" data-id="element-103">
              <span className="text-2xl" data-id="element-104">{module.emoji}</span>
              <span className="font-semibold text-gray-900" data-id="element-105">
                {module.title}
              </span>
            </div>
            <motion.div animate={{
          rotate: openIndex === index ? 180 : 0
        }} transition={{
          duration: 0.3
        }} data-id="element-106">
              <ChevronDownIcon className="w-5 h-5 text-gray-500" data-id="element-107" />
            </motion.div>
          </button>

          <AnimatePresence data-id="element-108">
            {openIndex === index && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3
        }} className="overflow-hidden" data-id="element-109">
                <div className="px-6 py-4 bg-gray-50 border-t border-gray-200" data-id="element-110">
                  <ul className="space-y-2" data-id="element-111">
                    {module.chapters.map((chapter, chapterIndex) => <li key={chapterIndex} className="text-gray-700 text-sm flex items-start gap-2" data-id="element-112">
                        <span className="text-emerald-500 mt-1" data-id="element-113">•</span>
                        <span data-id="element-114">{chapter}</span>
                      </li>)}
                  </ul>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>)}
    </div>;
}